import {createTrmzFileDTOConverter} from "@web-libs/features/files/trmz-file/api/trmz-file-dto-converter";

export const provideTrmzFileDtoConverter = (baseUrl:string, tenantId?: string) => {
    return createTrmzFileDTOConverter(baseUrl, tenantId)
}
